import TicTac from "../../modules/games/tic-tac-toe";
import RecallAndMatch from "../../modules/games/recall-and-match/RecallAndMatch";
import EightQueens from "../../modules/games/eight-queens/EightQueens";
import { SpinTheWheel } from "../../modules/games/spin-the-wheel/index";
import clsx from "clsx";

function Injections({
  type,
  isReset,
  resetIsReset,
  getScore,
  start,
  getStatus,
  getTotal,
  getMatches,
  handleResume,
  gameWon,
  getDifficulty,
  timerSeconds,
  timerMinutes,
  timerRunning,
}) {
  return (
    <div
      className={clsx(
        type === "spin_the_wheels"
          ? ""
          : "max-h-[80vh] overflow-y-auto hidden-scrollbar",
        "container min-h-[70vh] relative pt-[4%] 880:pt-[5%] pb-12 overflow-y-auto"
      )}
    >
      {type === "recall_and_match" && (
        <RecallAndMatch
          getStatus={getStatus}
          start={start}
          getTotal={getTotal}
          getMatches={getMatches}
          isReset={isReset}
          resetIsReset={resetIsReset}
          handleResume={handleResume}
          getDifficulty={getDifficulty}
          timerSeconds={timerSeconds}
          timerMinutes={timerMinutes}
          timerRunning={timerRunning}
        />
      )}
      {type === "tic tac toe" && (
        <TicTac
          isReset={isReset}
          resetIsReset={resetIsReset}
          getScore={getScore}
        />
      )}
      {type === "eight queens" && (
        <EightQueens
          resetIsReset={resetIsReset}
          isReset={isReset}
          gameWon={gameWon}
        />
      )}
      {type === "spin_the_wheels" && (
        <>
          <SpinTheWheel />
        </>
      )}
    </div>
  );
}

export default Injections;
